class Mask {
	removeComma(text) {
		const string = String(text)
		if (text !== null) {
			return string.replace(/,/g, '')
		}
		return text
	}

	setDots(text, showDecimals = true) {
		if (text === null || text === undefined) {
			return text
		}

		const string = String(text).trim()

		const [integerPart, decimalPart] = string.split('.')

		const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

		if (showDecimals) {
			const formattedDecimal = decimalPart ? `,${decimalPart.padEnd(2, '0')}` : ',00'
			return `${formattedInteger}${formattedDecimal}`
		}

		return formattedInteger
	}

	removeDots(text) {
		const string = String(text)
		if (text !== null) {
			return string.replace(/\./g, '')
		}
		return text
	}
}
export default new Mask()
